import { DocsCtaLink } from "@/components/marketing/DocsCtaLink"
import { Section } from "@/components/marketing/elements/section"
import { Stat } from "@/components/marketing/sections/stats-three-column-with-description"
import { SCENARIO_MODEL_PILLARS } from "@/content/marketing/site-content"

export function MarketingScenarioModelSection() {
  return (
    <Section
      id="why"
      eyebrow="The model"
      headline="A Scenario with nothing left implicit"
      subheadline={
        <p>
          ArtlessDev is built out of one small unit: the Scenario — one thing your product does, described
          completely enough that anyone can check it without asking what you meant. Every Scenario carries two
          simple statuses: is it Draft, Published, or Deprecated, and has it actually been checked — Not
          attempted, Fit, or Gap. That same completeness is exactly what an AI coding agent needs to act on it.
        </p>
      }
      cta={<DocsCtaLink />}
    >
      <div className="grid grid-cols-1 gap-2 md:grid-cols-3">
        {SCENARIO_MODEL_PILLARS.map((pillar) => (
          <Stat key={pillar.title} stat={pillar.title} text={pillar.body} />
        ))}
      </div>
    </Section>
  )
}
